import React, { Fragment, useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { AGENCY_DASHBOARD_ROUTE } from "../../../constants/RoutePaths";
import { logout } from "../../../functions/CoreFunctions";
import logo from "../../../images/logo.png";
import { GrMoney } from "react-icons/gr";

export default function Sidebar(props) {
  const { brandlogo } = props;
  const [activeMenu, setActiveItem] = useState("/");
  let location = useLocation();
  useEffect(() => {
    let currentActive = window.location.pathname || "/";
    setActiveItem(currentActive);
  }, [location]);
  let history = useNavigate();
  let Logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to sign out",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sign Out",
    }).then((result) => {
      if (result.isConfirmed) {
        logout(history);
      }
    });
  };
  return (
    <Fragment>
      <div className="agency-sidebar agency-sidebar-hide">
        <Link to={AGENCY_DASHBOARD_ROUTE}>
          <img className="logo" src={logo} alt=""/>
        </Link>
        <ul>
          <li className={activeMenu === "/agency/dashboard" ? "active" : ""}>
            <Link
              to={{
                pathname: "/agency/dashboard",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25.523"
                height="19.848"
                viewBox="0 0 25.523 19.848"
              >
                <path
                  id="Icon_awesome-home"
                  data-name="Icon awesome-home"
                  d="M12.422,7.4,4.253,14.131v7.262a.709.709,0,0,0,.709.709l4.965-.013a.709.709,0,0,0,.705-.709V17.139a.709.709,0,0,1,.709-.709h2.836a.709.709,0,0,1,.709.709v4.238a.709.709,0,0,0,.709.711l4.963.014a.709.709,0,0,0,.709-.709V14.126L13.1,7.4A.54.54,0,0,0,12.422,7.4Zm12.9,4.573-3.7-3.053V2.785a.532.532,0,0,0-.532-.532H18.609a.532.532,0,0,0-.532.532V6L14.11,2.739a2.127,2.127,0,0,0-2.7,0L.192,11.975a.532.532,0,0,0-.071.749L1.251,14.1A.532.532,0,0,0,2,14.17L12.422,5.586a.54.54,0,0,1,.678,0L23.522,14.17a.532.532,0,0,0,.749-.071l1.13-1.374a.532.532,0,0,0-.075-.75Z"
                  transform="translate(0.001 -2.254)"
                />
              </svg>
              Dashboard
            </Link>
          </li>
          <li
            className={
              ["/agency/template", "/agency/create-template"].includes(
                activeMenu
              )
                ? "active"
                : ""
            }
          >
            <Link
              to={{
                pathname: "/agency/template",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.956"
                height="17.956"
                viewBox="0 0 17.956 17.956"
              >
                <path
                  id="Icon_material-dashboard"
                  data-name="Icon material-dashboard"
                  d="M4.5,14.475h7.98V4.5H4.5Zm0,7.98h7.98V16.47H4.5Zm9.975,0h7.98V12.48h-7.98Zm0-17.956v5.985h7.98V4.5Z"
                  transform="translate(-4.5 -4.5)"
                />
              </svg>
              Template
            </Link>
          </li>
          <li
            className={["/agency/license"].includes(activeMenu) ? "active" : ""}
          >
            <Link
              to={{
                pathname: "/agency/license",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.834"
                height="17.657"
                viewBox="0 0 18.834 17.657"
              >
                <path
                  id="Icon_awesome-dog"
                  data-name="Icon awesome-dog"
                  d="M18.245,4.6H15.891l-.263-.526a1.177,1.177,0,0,0-1.053-.651H12.6l-1-1a.589.589,0,0,0-1,.416V8.352L15.3,10.033V8.724H16.48A2.354,2.354,0,0,0,18.834,6.37V5.193A.588.588,0,0,0,18.245,4.6ZM14.125,6.37a.589.589,0,1,1,.589-.589A.588.588,0,0,1,14.125,6.37ZM3.531,9.313A1.179,1.179,0,0,1,2.354,8.136,1.177,1.177,0,0,0,0,8.136,3.525,3.525,0,0,0,2.354,11.45v7.868a.588.588,0,0,0,.589.589H5.3a.588.588,0,0,0,.589-.589V15.2h5.886v4.12a.588.588,0,0,0,.589.589h2.354a.588.588,0,0,0,.589-.589V11.283L9.787,9.313Z"
                  transform="translate(0 -2.25)"
                />
              </svg>
              License
            </Link>
          </li>
          <li
            className={
              ["/agency/kernellicense"].includes(activeMenu) ? "active" : ""
            }
          >
            <Link
              to={{
                pathname: "/agency/kernellicense",
              }}
            >
              <svg
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z" />
              </svg>
              Kennel License
            </Link>
          </li>
          <li
            className={
              [
                "/agency/customer",
                "/agency/customer-details",
                "/agency/view-license",
              ].includes(activeMenu)
                ? "active"
                : ""
            }
          >
            <Link
              to={{
                pathname: "/agency/customer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.053"
                height="19.637"
                viewBox="0 0 28.053 19.637"
              >
                <path
                  id="Icon_awesome-users"
                  data-name="Icon awesome-users"
                  d="M4.208,10.666A2.805,2.805,0,1,0,1.4,7.861,2.808,2.808,0,0,0,4.208,10.666Zm19.637,0A2.805,2.805,0,1,0,21.04,7.861,2.808,2.808,0,0,0,23.845,10.666Zm1.4,1.4H22.442a2.8,2.8,0,0,0-1.977.815,6.411,6.411,0,0,1,3.292,4.8H26.65a1.4,1.4,0,0,0,1.4-1.4v-1.4A2.808,2.808,0,0,0,25.248,12.068Zm-11.221,0A4.909,4.909,0,1,0,9.117,7.159,4.907,4.907,0,0,0,14.026,12.068Zm3.366,1.4h-.364a6.778,6.778,0,0,1-6.005,0H10.66a5.051,5.051,0,0,0-5.05,5.05v1.262a2.1,2.1,0,0,0,2.1,2.1H20.338a2.1,2.1,0,0,0,2.1-2.1V18.521A5.051,5.051,0,0,0,17.393,13.471Zm-9.805-.587a2.8,2.8,0,0,0-1.977-.815H2.805A2.808,2.808,0,0,0,0,14.874v1.4a1.4,1.4,0,0,0,1.4,1.4H4.291A6.428,6.428,0,0,1,7.587,12.884Z"
                  transform="translate(0 -2.25)"
                />
              </svg>
              Customer
            </Link>
          </li>
          <li
            className={
              ["/agency/guestuser"].includes(activeMenu) ? "active" : ""
            }
          >
            <Link
              to={{
                pathname: "/agency/guestuser",
              }}
            >
              <GrMoney fill="#7a7a7a" width="26.053" height="18.637" />
              {/* <svg
                width="26.053"
                height="18.637"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z" />
              </svg> */}
              POS Sale
            </Link>
          </li>
          <li
            className={
              ["/agency/employee"].includes(activeMenu) ? "active" : ""
            }
          >
            <Link
              to={{
                pathname: "/agency/employee",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.064"
                height="15.8"
                viewBox="0 0 17.064 15.8"
              >
                <path
                  id="Icon_metro-suitcase"
                  data-name="Icon metro-suitcase"
                  d="M20.3,21.584H5.763A1.264,1.264,0,0,1,4.5,20.32V12.736a32.182,32.182,0,0,0,6.32,2.391V15.9a.631.631,0,0,0,.632.632h3.16a.632.632,0,0,0,.632-.632v-.769a32.2,32.2,0,0,0,6.32-2.391V20.32A1.264,1.264,0,0,1,20.3,21.584ZM13.979,14a.632.632,0,0,1,.632.632v.632a.632.632,0,0,1-.632.632h-1.9a.631.631,0,0,1-.632-.632v-.632A.631.631,0,0,1,12.083,14Zm1.264,0a.632.632,0,0,0-.632-.632h-3.16a.631.631,0,0,0-.632.632v.566A31.657,31.657,0,0,1,4.5,12.1V9.576A1.264,1.264,0,0,1,5.763,8.312H9.555V7.048a1.264,1.264,0,0,1,1.264-1.264h4.424a1.264,1.264,0,0,1,1.264,1.264V8.312H20.3a1.264,1.264,0,0,1,1.264,1.264V12.1a31.675,31.675,0,0,1-6.32,2.462V14Zm0-6.32a.632.632,0,0,0-.632-.632h-3.16a.631.631,0,0,0-.632.632v.632h4.424Z"
                  transform="translate(-4.499 -5.784)"
                />
              </svg>
              Employee
            </Link>
          </li>
          <li
            className={
              ["/agency/settings"].includes(activeMenu) ? "active" : ""
            }
          >
            <Link to={{ pathname: "/agency/settings" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18.559"
                height="19.079"
                viewBox="0 0 18.559 19.079"
              >
                <path
                  id="Icon_material-settings"
                  data-name="Icon material-settings"
                  d="M19.775,13.475a6.578,6.578,0,0,0,0-1.87l2.013-1.574A.481.481,0,0,0,21.9,9.42l-1.908-3.3a.479.479,0,0,0-.582-.21l-2.375.954a6.97,6.97,0,0,0-1.612-.935L15.063,3.4A.465.465,0,0,0,14.6,3H10.78a.465.465,0,0,0-.467.4L9.95,5.929a7.329,7.329,0,0,0-1.612.935L5.962,5.91a.465.465,0,0,0-.582.21L3.472,9.42a.47.47,0,0,0,.114.611L5.6,11.6a7.566,7.566,0,0,0-.067.935,7.566,7.566,0,0,0,.067.935L3.587,15.049a.481.481,0,0,0-.114.611l1.908,3.3a.479.479,0,0,0,.582.21l2.375-.954a6.97,6.97,0,0,0,1.612.935l.363,2.528a.465.465,0,0,0,.467.4H14.6a.465.465,0,0,0,.467-.4l.363-2.528a7.329,7.329,0,0,0,1.612-.935l2.375.954a.465.465,0,0,0,.582-.21l1.908-3.3a.481.481,0,0,0-.114-.611l-2.013-1.574Zm-7.088,2.4a3.339,3.339,0,1,1,3.339-3.339A3.343,3.343,0,0,1,12.687,15.879Z"
                  transform="translate(-3.406 -3)"
                />
              </svg>
              Settings
            </Link>
          </li>

          <li
            className={
              [
                "/agency/customerpaymentreport",
                "/agency/licensereport",
                "/agency/customerreport",
              ].includes(activeMenu)
                ? "active"
                : ""
            }
          >
            <Link to={{ pathname: "/agency/licensereport" }}>
              <svg
                width="18"
                height="18"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path d="M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 299.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-70.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v70.4zm96 0c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V236.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v198.4zm32-134.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v134.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V300.8z" />
              </svg>
              Report
            </Link>
          </li>
          {[
            "/agency/customerpaymentreport",
            "/agency/licensereport",
            "/agency/customerreport",
          ].includes(activeMenu) ? (
            <>
              <li
                className={
                  ["/agency/licensereport"].includes(activeMenu)
                    ? "submenu active"
                    : "submenu"
                }
              >
                <Link to={{ pathname: "/agency/licensereport" }}>
                  <svg
                    width="8"
                    height="8"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
                  </svg>
                  License Report
                </Link>
              </li>

              <li
                className={
                  ["/agency/customerreport"].includes(activeMenu)
                    ? "submenu active"
                    : "submenu"
                }
              >
                <Link to={{ pathname: "/agency/customerreport" }}>
                  <svg
                    width="8"
                    height="8"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
                  </svg>
                  Customer Report
                </Link>
              </li>

              <li
                className={
                  ["/agency/customerpaymentreport"].includes(activeMenu)
                    ? "submenu active"
                    : "submenu"
                }
              >
                <Link to={{ pathname: "/agency/customerpaymentreport" }}>
                  <svg
                    width="8"
                    height="8"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" />
                  </svg>
                  Customer Payment Report
                </Link>
              </li>
            </>
          ) : (
            ""
          )}
          <li className="" onClick={Logout}>
            <Link>
              <svg
                width="20"
                height="20"
                xmlns="http://www.w3.org/2000/svg"
                fill="#e4efff"
                viewBox="0 0 512 512"
              >
                <path d="M180 448H96c-53 0-96-43-96-96V160c0-53 43-96 96-96h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H96c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm117.9-303.1l77.6 71.1H184c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h191.5l-77.6 71.1c-10.1 9.2-10.4 25-.8 34.7l21.9 21.9c9.3 9.3 24.5 9.4 33.9.1l152-150.8c9.5-9.4 9.5-24.7 0-34.1L353 88.3c-9.4-9.3-24.5-9.3-33.9.1l-21.9 21.9c-9.7 9.6-9.3 25.4.7 34.6z" />
              </svg>
              Logout
            </Link>
          </li>
          <li>
            <div className="company-logo">
              <img src={brandlogo} alt=""/>
            </div>
          </li>
        </ul>
      </div>
    </Fragment>
  );
}
